module.exports = __webpack_public_path__ + "img/s1-1.232aadc5.jpg";